module.exports = __webpack_public_path__ + "img/pp.1882c70.svg";


//////////////////
// WEBPACK FOOTER
// ./assets/img/pp.svg
// module id = ./assets/img/pp.svg
// module chunks = 9